"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    notFound: {
        title: 'Oh, snap!',
        message: 'The page you requested does not exist or has been removed.',
    },
};
